import api from '@pray/shared/utils/api';

export async function getConversations({ artistId, cursor = null, limit = 20 } = {}) {
  if (!artistId) throw Error('Artist ID is required');

  const params = {};
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;

  const url = `/web/studio/artists/${artistId}/conversations`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
